export default "__VITE_ASSET__CPJC8Tt9__"